<script setup>
const props = defineProps({
  carrousel: String,
});
</script>

<template>
  <div class="">
    {{ carrousel }}
  </div>
</template>

<style></style>
